import * as React from 'react'
import CenteredViewLayout from './CenteredViewLayout'

type ErrorProps = {
  icon: JSX.Element
  title?: string
  text?: string | JSX.Element
}

const Error = ({ icon, title, text }: ErrorProps): JSX.Element => (
  <CenteredViewLayout illustration={icon} title={title}>
    {text}
  </CenteredViewLayout>
)

export default Error
